import { jsx as _jsx } from "react/jsx-runtime";
import { Divider as MUIDivider } from "@mui/material";
var Divider = function () {
    return _jsx(MUIDivider, { light: true, sx: { bgcolor: "#DEE1F2", py: "0", my: "16px" } });
};
export default Divider;
